import React, { useEffect, useState, useMemo } from 'react'
import styled from 'styled-components'
import { withRouteData, Head } from 'react-static'
import TransitionGroup from 'react-transition-group/TransitionGroup'

import Top from '../components/pages/home/HomeTop'
import Gallery from '../components/pages/home/HomeGallery'
import People from '../components/pages/home/HomePeople'
import Listen from '../components/pages/home/HomeListen'
import Bottom from '../components/pages/home/HomeBottom'
import Loader from '../components/common/loader/Loader'
import TransitionContainer from '../components/common/TransitionContainer'
import { slides } from '../data/slideshow'

const Wrapper = styled.div`
  overflow: hidden;
  position: relative;
`

let hideLoader = false

const Home = ({ people, listen }) => {
  const [slidesLoaded, setSlidesLoaded] = useState([])
  const [isMobile, setIsMobile] = useState(true)
  const [isPortrait, setIsPortrait] = useState(true)
  const isReady = useMemo(() => slidesLoaded.includes(0), [slidesLoaded])

  useEffect(() => {
    loadImages(0)
    detectWindowWidth()
    window.addEventListener('resize', detectWindowWidth)

    return () => {
      window.removeEventListener('resize', detectWindowWidth)
    }
  }, [])

  function detectWindowWidth() {
    if (typeof window === 'undefined') return

    setIsMobile(window.innerWidth < 601)
    setIsPortrait(window.innerWidth < window.innerHeight)
  }

  function loadImages(i) {
    if (typeof document === 'undefined') return

    const slide = new Image()
    slide.src = window.innerWidth < 601 ? slides[i].srcMobile : slides[i].src
    slide.addEventListener('load', () => imageLoaded(i))
  }

  function imageLoaded(i) {
    if (i === 0) {
      hideLoader = true
    }

    setSlidesLoaded(prev => [...prev, i])

    setTimeout(() => {
      if (i < slides.length - 1) {
        loadImages(i + 1)
      }
    }, 0)
  }

  return (
    <Wrapper>
      <Head>
        <meta
          name="description"
          content="Welcome to Bagnall Hill Studio - A boutique recording studio in Te Pahu, Waikato, housing a unique assortment of analogue gear, microphones and instruments."
        />
        <title>Home</title>
      </Head>
      <Top slides={slides} ready={isReady} mobile={isMobile} />
      <Gallery mobile={isMobile} />
      <People people={people} />
      <Listen listen={listen} />
      <Bottom mobile={isMobile || isPortrait} />
      <TransitionGroup component={TransitionContainer}>
        {!isReady && !hideLoader && <Loader />}
      </TransitionGroup>
    </Wrapper>
  )
}

export default withRouteData(Home)



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/Home.js